import { Header } from '../components/Header/Header';
import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardHeader } from '../components/CardHeader/CardHeader';
import { CardBody } from '../components/CardBody/CardBody';
import {Col, Row, Spinner, Container, Button} from 'react-bootstrap';
import {useCallback, useEffect, useState} from 'react';
import { api } from '../services/Api';
import {useHistory} from "react-router-dom";
import {useAlert} from "../contexts/AlertContext";
import { CreditCard } from '../components/CreditCard/CreditCard';
import {useAuth} from "../contexts/AuthenticationContext";

type CreditCardType = {
	id: number;
	bandeira: string;
	nome_titular: string;
	numero: string;
	validade: string;
}

type ProfileType= {
	bairro: string;
	celular: string;
	cep: string;
	cidade: string;
	complemento: string;
	documento: string;
	email: string;
	endereco: string;
	endereco_numero: number;
	estado: string;
	id: number;
	nome: string;
	telefone: string;
	uf: string;
}
export function Profile() {
	const history = useHistory();

	const { session } = useAuth();

	const { handleSetAlert } = useAlert();

	const [profile, setProfile] = useState<ProfileType | null>(null);
	const [cards, setCards] = useState<CreditCardType[] | null>(null);
	const [loadingProfile, setLoadingProfile] = useState(false);
	const [loadingCards, setLoadingCards] = useState(false);

	const handleLoad = useCallback( (removeCard) => {
		if(session){
			if (removeCard) {
				setLoadingCards(true);
			} else {
				setLoadingProfile(true);
				setLoadingCards(true);
			}

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/pessoas/clientes/perfil', { headers })
				.then((response) => {
					if (removeCard) {
						setCards(response.data.cartoes);
					} else {
						setProfile(response.data);
						setCards(response.data.cartoes);
					}
					setLoadingProfile(false);
					setLoadingCards(false);
				})
				.catch(error => {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: error.response.data.message,
						timeout: 5000
					});
					history.goBack();
					setLoadingProfile(false);
					setLoadingCards(false);
				});
		}
	},[session, history, handleSetAlert]);

	useEffect(() => {
		handleLoad(false);
	}, [handleLoad]);

	function handleRemove(id: number) {
		if (session) {

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			let data = {
				id: id
			}

			api.post('v1/pessoas/clientes/remover-cartao', data, { headers })
				.then(() => {
					handleSetAlert({
						visible: true,
						variant: 'success',
						message: 'Cartão de crédito removido com sucesso',
						timeout: 5000
					});
					handleLoad(true);
				}).catch(() => {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Não foi possivel realizar a operação',
					timeout: 5000
				});
			});
		}
	};

	return(
		<>
			<Header />
			<Container>
				<Row className="m-3">
					<Col md={6} sm={6} className="d-flex w-50 p-0">
						<h3 className="title-page d-flex">
							<Button variant={""} className="d-flex shadow-none p-0" onClick={() => {history.goBack()}}>
								<span className="material-icons title-icon">keyboard_arrow_left</span>
							</Button>
							<span className="material-icons title-icon">face</span>
							Perfil
						</h3>
					</Col>
					<Col md={6} sm={6} className="d-flex justify-content-end text w-50 p-0">
						<Button className="d-flex align-items-center" variant="light" onClick={() => {history.push('/configuracoes')}}>
							<span className="material-icons title-icon me-2">settings</span>
							Configurações
						</Button>
					</Col>
				</Row>
				<Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">info</span>
										Informações
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingProfile && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingProfile && <Col md={12}>
											<p><b>Nome: </b>{profile?.nome}</p>
											<p><b>Documento: </b>{profile?.documento}</p>
											<p><b>Celular: </b>{profile?.celular}</p>
											<p><b>Telefone: </b>{profile?.telefone}</p>
											<p><b>Endereço: </b>{profile?.endereco} N°{profile?.endereco_numero}, {profile?.bairro} - {profile?.cidade}</p>
											<p><b>Email: </b>{profile?.email}</p>
										</Col>
										}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">credit_card</span>
										Cartões de Crédito
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingCards && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingCards && cards?.length === 0 && <div className="justify-content-center align-items-center d-flex">
											<p className="text-center">Nenhum cartão de crédito cadastrado</p>
										</div>
										}
										{!loadingCards && cards?.length !== 0 && <>
											{cards?.map((card: CreditCardType, key) => ( <div key={key}>
													<CreditCard card={card} lastItem={cards?.length >= 1 && key !== cards?.length-1} handleRemoveCard={handleRemove}/>
												</div>
											))}
										</>
										}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
				</Row>
			</Container>
		</>
	);
}
